<template>
  <Layout>
    <div>
      <!-- <h1>{{ selectedSession ? 'Attendance Certificate' : 'Select Conference' }}</h1> -->
       <h1>Attendance Certificate</h1>
      <h2 style="color: #666; font-size: 1.2rem;">{{ selectedSession ? '' : 'Please first select the meetings you have registered for or attended' }}</h2>
      <!-- 加载状态 -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
        </div>
      </div>
      
      <!-- 错误状态 -->
      <div v-else-if="error" class="alert alert-danger" role="alert">
        <h4 class="alert-heading">加载失败</h4>
        <p>{{ error }}</p>
        <hr>
        <div class="d-flex gap-2">
          <button class="btn btn-primary" @click="getAttendance">重新加载</button>
          <button class="btn btn-outline-secondary" @click="backToSessionList">选择其他会议</button>
        </div>
      </div>
      
      <!-- 会议选择 -->
      <div v-if="!selectedSession" class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4>Select Conference</h4>
            </div>
            <div class="card-body">
              <div class="alert alert-info mb-3">
                <i class="fa fa-info-circle"></i>
                <strong>Tips:</strong> Only the conferences you have registered for or attended will be displayed. If you do not see the attendance record for a conference, please confirm that you have registered for the conference correctly.
              </div>
              
              <div v-if="sessionListLoading" class="text-center py-3">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden"></span>
                </div>
              </div>
              
              <div v-else-if="sessionListError" class="alert alert-danger">
                <p>{{ sessionListError }}</p>
                <button class="btn btn-primary" @click="getSessionList">Reload</button>
              </div>
              
              <div v-else-if="sessionList && sessionList.length > 0" class="session-list">
                <div class="row">
                  <div v-for="session in sessionList" :key="session.id" class="col-md-6 mb-3">
                    <div class="card session-card" @click="selectSession(session)" :class="{ 'border-primary': session.status == 1 }"  style="cursor: pointer; border: none">
                      <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <h5 class="card-title mb-0">{{ session.title || session.sessionname }}</h5>
                          <span class="badge" :class="getSessionStatusClass(session.status)">
                            {{ getSessionStatusText(session.status) }}
                          </span>
                        </div>
                        <p class="card-text small">
                          <!-- <strong>Session ID:</strong> {{ session.session_no || session.codeid }} -->
                          <strong>Dates:</strong> 14 - 16 Nov, 2025
                        </p>
                        <p class="card-text small">
                          <!-- <strong>Conveners:</strong> {{ session.conveners ? (session.conveners.length > 20 ? session.conveners.substring(0, 20) + '...' : session.conveners) : 'Not specified' }} -->
                          <strong>loction:</strong> Penang, Malaysia
                        </p>
                        <!-- <div class="row">
                          <div class="col-6">
                            <p class="card-text small">
                              <strong>Room:</strong> {{ session.room || 'Not specified' }}
                            </p>
                          </div>
                          <div class="col-6">
                            <p class="card-text small">
                              <strong>Duration:</strong> {{ session.duration || 'Not specified' }}
                            </p>
                          </div>
                        </div>
                        <p class="card-text small">
                          <strong>Time:</strong> {{ session.time || 'Not specified' }}
                        </p>
                        <div class="text-center mt-2">
                          <small class="text-muted">
                            <i class="fa fa-certificate"></i> Click to view the attendance certificate
                          </small>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div v-else class="text-center py-4">
                <p class="text-muted">No available meetings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 主要内容 -->
      <div v-else class="row">
        <div class="col-md-8">
          <div class="card" ref="certificateCard">
            <div class="card-header">
             
              <h3>Certificate of Attendance</h3>
            </div>
            <div class="card-body" ref="certificateBody">
              <div class="certificate-content">
                <div class="certificate-header text-center">
                  <img src="../../public/isacio.png" alt="ISACI Logo" class="logo" style="width: 300px;">
                  <h2>{{ conference.name || 'ISACI 2025' }}</h2>
                  <!-- <h3>{{ conference.name || '22nd Annual Meeting' }}</h3> -->
                  <!-- <p class="conference-dates">{{ conference.dates || 'Nov 14-16, 2025' }}</p> -->
                  <!-- <p class="conference-venue">{{ conference.location || 'Penang, Malaysia' }}</p> -->
                  <!-- <p class="conference-venue">{{ 'Penang, Malaysia' }}</p> -->
                </div>
                
                <div class="certificate-body">
                  <p class="certificate-text">
                    This is to certify that
                  </p>
                  <div class="participant-name">
                    <h4>{{ participant.name }}</h4>
                  </div>
                  <p class="certificate-text">
                    from <strong>{{ participant.organization }}</strong>
                  </p>
                  <p class="certificate-text">
                    has successfully attended the {{ conference.name || 'ISACI 2025' }} held at Penang, Malaysia during the period
                  </p>
                  
                  <!-- <div class="activities-list">
                    <ul v-if="participant.activities && participant.activities.length > 0">
                      <li v-for="activity in participant.activities" :key="activity.id">
                        {{ activity.name }} - {{ activity.date }}
                        <span v-if="activity.type" class="activity-type">({{ activity.type }})</span>
                        <span v-if="activity.duration" class="activity-duration">- {{ activity.duration }} hours</span>
                        <span v-if="activity.location" class="activity-location">at {{ activity.location }}</span>
                      </li>
                    </ul>
                    <div v-else class="no-activities">
                      <p class="text-muted">There are no activity records for the time being</p>
                    </div>
                  </div> -->
                  <div class="activities-list">
                    <p>14 November to 16 November, 2025</p>
                  </div>
                </div>
                <div class="footer-info">
                  <table>
                    <tr>
                      <td>
                        ISACI
      <br>
                        #33A Pagoda Street, Singapore 059192 <br>
                         Email: <a href="mailto:isaci.contact@gmail.com">isaci.contact@gmail.com</a><br>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- <div class="certificate-footer">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="signature-section">
                        <div class="signature-line"></div>
                        <p class="signature-name">Dr. Ji Chen</p>
                        <p class="signature-title">ISACI Secretary General</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="signature-section">
                        <div class="signature-line"></div>
                        <p class="signature-name">Prof. Chun-Chieh Wu</p>
                        <p class="signature-title">ISACI President</p>
                      </div>
                    </div>
                  </div>
                  
                  <div class="certificate-date">
                    <p>Date: {{ certificateDate }}</p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h4>Certificate Actions</h4>
              <button class="btn btn-outline-secondary btn-sm" @click="backToSessionList">
                <i class="fa fa-arrow-left"></i>  Back
              </button>
            </div>
            <div class="card-body">
              <div class="d-grid gap-2">
                <button class="btn btn-primary" @click="printCertificate">
                  <i class="fa fa-print"></i> Print Certificate
                </button>
                <button class="btn btn-success" @click="downloadPDF">
                  <i class="fa fa-download"></i> Download PDF
                </button>
                <button class="btn btn-info" @click="emailCertificate">
                  <i class="fa fa-envelope"></i> Email Certificate
                </button>
                <!-- <button class="btn btn-warning" @click="verifyCertificate">
                  <i class="fa fa-check-circle"></i> Verify Certificate
                </button> -->
              </div>
              
              <!-- <h5>Certificate Details</h5>
              <div class="certificate-details">
                <p><strong>Certificate ID:</strong> {{ certificateId }}</p>
                <p><strong>Issue Date:</strong> {{ certificateDate }}</p>
                <p><strong>Status:</strong> <span class="badge badge-success">Valid</span></p>
                <p><strong>Total Hours:</strong> {{ participant.totalHours || conference.totalTime }} hours</p>
                <p><strong>Sessions Attended:</strong> {{ participant.activities.length }}</p>
              </div>
              
              <hr>
              
              <h5>Conference Information</h5>
              <div class="conference-details">
                <p><strong>Conference:</strong> {{ conference.name }}</p>
                <p><strong>Dates:</strong> {{ conference.dates }}</p>
                <p><strong>Location:</strong> {{ conference.location }}</p>
                <p><strong>Conveners:</strong> {{ conference.conveners }}</p>
                <p><strong>Conference ID:</strong> {{ conference.conferenceId }}</p>
                <p><strong>Selected Session:</strong> {{ selectedSession ? (selectedSession.title || selectedSession.sessionname) : '未选择' }}</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 隐藏的iframe用于打印 -->
    <iframe 
      ref="printFrame" 
      style="display: none;"
      @load="onIframeLoad">
    </iframe>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { apiService } from '@/config/api'

export default {
  name: 'ProofAttendance',
  components: {
    Layout
  },
  data() {
    return {
      loading: false,
      error: null,
      sessionListLoading: false,
      sessionListError: null,
      sessionList: [],
      selectedSession: null,
      participant: {
        name: '',
        organization: '',
        totalHours: 0,
        activities: []
      },
      conference: {
        name: '',
        dates: '',
        location: '',
        conferenceId: '',
        totalTime: 0,
        conveners: '',
        startDate: '',
        endDate: ''
      },
      session_id: '',
      certificateId: '',
      certificateDate: new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  },
  created() {
    // 组件创建时的初始化
  },
  mounted() {
    // 组件挂载后获取会议列表
    
    // 使用 nextTick 确保DOM更新完成后再调用API
    this.$nextTick(() => {
      this.getSessionList()
    })
  },
  methods: {
    // 获取会议列表
    getSessionList() {
      this.sessionListLoading = true
      this.sessionListError = null
      
      try {
        apiService.sessions.getMySessionList().then(response => {
          if (response.data && response.data.code === 1 && response.data.data) {
            // 检查数据结构
            if (response.data.data.success && response.data.data.list) {
              this.sessionList = response.data.data.list
            } else if (Array.isArray(response.data.data)) {
              this.sessionList = response.data.data
            } else {
              this.sessionList = []
            }
          } else {
            this.sessionListError = response.data?.msg || '获取会议列表失败'
          }
        }).catch(error => {
          console.error('获取会议列表错误:', error)
          this.sessionListError = '网络错误，请稍后重试'
        }).finally(() => {
          this.sessionListLoading = false
        })
      } catch (error) {
        console.error('API调用错误:', error)
        this.sessionListError = 'API调用失败'
        this.sessionListLoading = false
      }
    },
    
    // 选择会议
    selectSession(session) {
      this.selectedSession = session
      this.session_id = session.id
      this.getAttendance()
    },
    
    // 返回会议选择
    backToSessionList() {
      this.selectedSession = null
      this.session_id = ''
      this.participant = {
        name: '',
        organization: '',
        totalHours: 0,
        activities: []
      }
      this.conference = {
        name: '',
        dates: '',
        location: '',
        conferenceId: '',
        totalTime: 0,
        conveners: '',
        startDate: '',
        endDate: ''
      }
      this.certificateId = ''
      this.error = null
    },
    
    // 获取会议状态样式类
    getSessionStatusClass(status) {
      const statusMap = {
        '1': 'badge-success',
        '2': 'badge-warning',
        '0': 'badge-secondary',
        '-1': 'badge-danger'
      }
      return statusMap[status] || 'badge-info'
    },
    
    // 获取会议状态文本
    // getSessionStatusText(status) {
    //   const statusMap = {
    //     '1': '进行中',
    //     '2': '即将开始',
    //     '0': '已结束',
    //     '-1': '已取消'
    //   }
    //   return statusMap[status] || '未知状态'
    // },
    getSessionStatusText(status) {
      const statusMap = {
        '1': 'In Progress',
        '2': 'Starting Soon',
        '0': 'Finished',
        '-1': 'Cancelled'
      }
      return statusMap[status] || 'Unknown Status'
    },
    // 获取相关信息
    getAttendance() {
      if (!this.session_id) {
        this.error = 'Please select a conference first'
        return
      }
      
      this.loading = true
      this.error = null
      apiService.registration.getAttendance({
        session_id: this.session_id
      }).then(response => {
        if (response.data && response.data.code === 1 && response.data.data) {
          this.participant = response.data.data.participant
          this.conference = response.data.data.conference
          this.certificateId = response.data.data.conference.conferenceId
        } else if (response.data && response.data.code === 404) {
          this.error = 'You have not attended this conference or the conference information does not exist. Please select another conference or contact the administrator to confirm your attendance status.'
        } else {
          this.error = response.data?.msg || 'Failed to get data'
        }
      }).catch(error => {
        console.error('Failed to get attendance information:', error)
        if (error.response && error.response.status === 404) {
          this.error = 'You have not attended this conference or the conference information does not exist. Please select another conference or contact the administrator to confirm your attendance status.'
        } else {
          this.error = 'Network error, please try again later'
        }
      }).finally(() => {
        this.loading = false
      })
    },
    
    
    printCertificate() {
      // 创建打印内容
      const printContent = this.createPrintContent()
      
      // 获取iframe
      const iframe = this.$refs.printFrame
      
      // 写入内容到iframe
      iframe.contentDocument.open()
      iframe.contentDocument.write(printContent)
      iframe.contentDocument.close()
      
      // 等待iframe加载完成后打印
      iframe.onload = () => {
        iframe.contentWindow.print()
      }
    },
    
    createPrintContent() {
      const conferenceName = this.conference.name || 'ISACI 2025'
      const participantName = this.participant.name || 'Participant Name'
      const organization = this.participant.organization || '—'
      const location = this.conference.location || 'Penang, Malaysia'
      const totalHoursValue = this.participant.totalHours ?? this.conference.totalTime
      const totalHours = totalHoursValue === 0 || totalHoursValue ? totalHoursValue : '--'

      const formatDate = dateString => {
        if (!dateString) return null
        const date = new Date(dateString)
        if (Number.isNaN(date.getTime())) return null
        return date.toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })
      }

      const startDate = formatDate(this.conference.startDate)
      const endDate = formatDate(this.conference.endDate)
      let dateRange = ''
      if (startDate && endDate) {
        dateRange = `${startDate} to ${endDate}`
      } else if (this.conference.dates) {
        dateRange = this.conference.dates
      } else {
        dateRange = '14 November 2025 to 16 November 2025'
      }

      const certificateId = this.certificateId || '—'

      return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>ISACI 2025 Certificate of Attendance</title>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              height: 100%;
              font-family: 'Times New Roman', 'Microsoft YaHei', serif;
              color: #1f2937;
              background: #f3f4f6;
            }

            body {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 18mm 0;
              box-sizing: border-box;
            }

            .page {
              width: 210mm;
              max-width: 90%;
              background: #ffffff;
              border: 1px solid #1d4ed8;
              border-radius: 16px;
              padding: 15mm 25mm 25mm 25mm;
              box-sizing: border-box;
              box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);
              text-align: center;
            }

            .logo {
              width: 220px;
              margin: 0 auto 20px;
            }

            .conference-title {
              font-size: 26pt;
              font-weight: 700;
              letter-spacing: 1.5px;
              color: #1d4ed8;
              margin-bottom: 6px;
              text-transform: uppercase;
            }

            .certificate-subtitle {
              font-size: 18pt;
              letter-spacing: 6px;
              font-weight: 500;
              text-transform: uppercase;
              color: #475467;
              margin-bottom: 20px;
              margin-top: 10px;
            }

            .divider {
              width: 80px;
              height: 3px;
              background: linear-gradient(90deg, #1d4ed8, #93c5fd);
              margin: 0 auto 26px;
            }

            .intro-line {
              font-size: 18pt;
              color: #475467;
              letter-spacing: 1px;
              margin-bottom: 14px;
            }

            .participant-name {
              font-size: 30pt;
              letter-spacing: 4px;
              font-weight: 700;
              color: #0f172a;
              margin-bottom: 12px;
              text-transform: uppercase;
            }

            .organization-line {
              font-size: 18pt;
              margin-bottom: 22px;
              color: #1f2937;
            }

            .organization-line span {
              font-weight: 600;
              color: #1d4ed8;
            }

            .description {
              font-size: 21pt;
              line-height: 1.8;
              color: #334155;
              margin-bottom: 16px;
            }

            .description strong {
              color: #1d4ed8;
            }

            .date-range {
              font-size: 22pt;
              font-weight: 600;
              color: #111827;
              margin-bottom: 18px;
            }

            .hours-line {
              font-size: 13pt;
              color: #374151;
              margin-bottom: 40px;
            }

            .hours-line span {
              font-weight: 600;
              color: #1d4ed8;
            }

            .issued-row {
              display: flex;
              justify-content: center;
              gap: 40px;
              margin-bottom: 50px;
              flex-wrap: wrap;
            }

            .issued-item {
              text-align: center;
            }

            .issued-item .label {
              display: block;
              font-size: 11pt;
              color: #6b7280;
              letter-spacing: 1px;
              text-transform: uppercase;
              margin-bottom: 6px;
            }

            .issued-item .value {
              display: block;
              font-size: 12.5pt;
              color: #0f172a;
              font-weight: 600;
            }

            .footer {
              border-top: 1px solid #cbd5f5;
              padding-top: 20px;
            }

            .footer-org {
              font-size: 13pt;
              font-weight: 600;
              letter-spacing: 2px;
              margin-bottom: 6px;
            }

            .footer-address,
            .footer-contact {
              font-size: 11pt;
              color: #4b5563;
              margin: 0;
            }

            .footer-contact a {
              color: #1d4ed8;
              text-decoration: none;
            }

            .footer-contact a:hover {
              text-decoration: underline;
            }

            @page {
              size: A4 portrait;
              margin: 0;
            }
          </style>
        </head>
        <body>
          <div class="page">
            <img src="/isacio.png" alt="ISACI Logo" class="logo">
            <div class="conference-title">${conferenceName}</div>
            <div class="certificate-subtitle">Certificate of Attendance</div>
            <div class="divider"></div>

            <p class="intro-line">This is to certify that</p>
            <h1 class="participant-name">${participantName}</h1>
            <p class="organization-line">of <span>${organization}</span></p>

            <p class="description">has successfully attended the <strong>${conferenceName}</strong> held at Penang, Malaysia during the period</p>
            <p class="date-range"> 14 November to 16 November, 2025</p>

            <div class="footer">
              <p class="footer-org">ISACI</p>
              <p class="footer-address">#33A Pagoda Street, Singapore 059192</p>
              <p class="footer-contact">Email: <a href="mailto:isaci.contact@gmail.com">isaci.contact@gmail.com</a></p>
            </div>
          </div>
        </body>
        </html>
      `
    },
    
    onIframeLoad() {
      // iframe加载完成后的回调
    },
    
    downloadPDF() {
      // 使用浏览器原生的打印功能，然后用户可以选择保存为PDF
      this.printCertificate()
    },
    
    emailCertificate() {
      const subject = encodeURIComponent(`${this.conference.name || 'ISACI 2025'} Certificate of Attendance`)
      const body = encodeURIComponent(`Dear ${this.participant.name},\n\nPlease find your certificate of attendance attached.\n\nCertificate ID: ${this.certificateId}\n\nBest regards,\n${this.conference.name || 'ISACI 2025'} Secretariat`)
      window.open(`mailto:${this.participant.email}?subject=${subject}&body=${body}`)
    },
    
    verifyCertificate() {
      const verificationUrl = `https://verify.${this.conference.name?.toLowerCase().replace(/\s+/g, '') || 'aogs2025'}.org?id=${this.certificateId}`
      window.open(verificationUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.certificate-content {
  padding: 48px 48px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 60%, #ffffff 100%);
  min-height: 600px;
  max-width: 900px;
  margin: 0 auto;
  border-radius: 16px;
  font-family: 'Times New Roman', 'Microsoft YaHei', serif;
  color: #1f2933;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
}

.certificate-header img {
  width: 220px;
  margin-bottom: 24px;
}

.certificate-header h2 {
  color: #0f172a;
  font-size: 42px;
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.certificate-header h3 {
  color: #34495e;
  font-size: 24px;
  margin-bottom: 10px;
}

.conference-dates {
  font-size: 18px;
  color: #7f8c8d;
  margin-bottom: 5px;
}

.conference-venue {
  font-size: 16px;
  color: #95a5a6;
  margin-bottom: 30px;
}

.certificate-body {
  margin: 40px 0;
  text-align: center;
  font-size: 18px;
  line-height: 1.7;
  color: #344054;
}

.certificate-text {
  font-size: 25px;
  line-height: 1.8;
  margin-bottom: 20px;
}

.participant-name h4 {
  font-size: 38px;
  color: #0f172a;
  margin: 28px 0;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.activities-list {
  margin: 36px 0;
  font-size: 23px;
  text-align: center;
  color: #1d4ed8;
}

.activities-list ul {
  list-style: none;
  padding: 0;
}

.activities-list li {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}

.activities-list li:last-child {
  border-bottom: none;
}

.activity-type {
  color: #3498db;
  font-weight: bold;
  margin-left: 5px;
}

.activity-duration {
  color: #27ae60;
  margin-left: 5px;
}

.activity-location {
  color: #e74c3c;
  font-style: italic;
  margin-left: 5px;
}

.no-activities {
  text-align: center;
  padding: 20px;
  color: #95a5a6;
}

.certificate-footer {
  margin-top: 40px;
}

.signature-section {
  text-align: center;
  margin-bottom: 30px;
}

.signature-line {
  width: 200px;
  height: 2px;
  background-color: #333;
  margin: 0 auto 10px;
}

.signature-name {
  font-weight: bold;
  margin-bottom: 5px;
}

.signature-title {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.certificate-date {
  text-align: center;
  margin-top: 30px;
  font-size: 18px;
  color: #1f2933;
}

.certificate-details p {
  margin-bottom: 8px;
  font-size: 15px;
  color: #475467;
}

.conference-details p {
  margin-bottom: 8px;
  font-size: 15px;
  color: #475467;
}

.conference-details strong {
  color: #1f2933;
}

.session-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.session-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-color: #3498db;
}

.session-card .card-body {
  padding: 1rem;
}

.session-card .card-title {
  color: #2c3e50;
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
}

.session-card .card-text {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.session-card .badge {
  font-size: 0.8rem;
}

.verification-link a {
  color: #3498DB;
  text-decoration: none;
}

.verification-link a:hover {
  text-decoration: underline;
}

.d-grid.gap-2 {
  gap: 0.5rem;
}

.btn {
  width: 60%;
  margin-bottom: 10px;
}

.footer-info {
   margin-top: 60px;
  }
 .footer-info table {
  width: 100%;
  }
            
.footer-info td {
  font-family: 'Times New Roman', 'Microsoft YaHei', serif;
  font-size: 12px;
  text-align: center;
  color: #4b5563;
  line-height: 1.6;
}
            
@media print {
  .btn {
    display: none;
  }
  
  .col-md-4 {
    display: none;
  }
  
  .col-md-8 {
    width: 100%;
  }
  
  .certificate-content {
    border: none;
    padding: 20px;
  }
}
</style> 